import { Component, OnInit,Input,Output,EventEmitter } from '@angular/core';
import { GlobalService } from '../../../global.service';
import { Service } from '../../../services';
import { Router } from '@angular/router';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-billing',
  templateUrl: './billing.component.html',
  styleUrls: ['./billing.component.sass']
})
export class BillingComponent implements OnInit {

  @Input() screen;
  @Output() updatescreen = new EventEmitter();
  @Output() updateNroOrder = new EventEmitter();
  @Output() updateconfirmNum = new EventEmitter();
  @Output() updatepaymentID = new EventEmitter();
  @Output() updateInitializeData = new EventEmitter();
  @Input() dataPay;
  @Output() updatescreenview = new EventEmitter<any>();
  public amountPayable;
  public equipmenttoPay;

  public token:string=sessionStorage.getItem("token");
  public selectBan=atob(sessionStorage.getItem("selectBan"));
  public tipoTDC='';
  public months;
  public years;
  public year;
  public fechaExp2;
  public fechaExp1 = '01';
  public estados;
  public estado;

  public NameOnCard='';
  public idNroTejeta='';
  public cvNum='';
  public direccion1='';
  public ciudad='';
  public zip='';
  public emailGloba='';
  public fechaExp='';
  public direccion='';
  public direccion2='';

  public paymentID=12345;
  public confirmNum=1234;

  public actualPrice;
  // AddOffersToSubscriber/group
      public groupIDPay;
      public subscriberNumberPay;
      public billCycleFieldPay;
      public OfferIdPay;
      public userName=sessionStorage.getItem("userName");
  // fin AddOffersToSubscriber/group
      public socSva;
  // public amountPayable;
  // public equipmenttoPay;
  //giverecharge
    public banSendPay;
    public fullNamePay;
    public banRecievePay;
    public subsriberSendPay;
    public subsriberRecieverPay;
    public giftSendMessagePay;
    public paymentTypePay;

   public subscriberNumberSva;

   public transactionId;
   public returnPage;
   //changeplan
    public contractMonthsTxt;
    public currentSoc;
    public nextSoc;
    public actualType;
    public subscriberNumber;
    public currentPlan;
   //changeplan

  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService,private router: Router) { }

  ngOnInit() {
    this.months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    this.years = [];
    this.year = new Date();
    var anio = this.year.getFullYear();
    anio=parseInt(anio.toString().substring(2,4));
    for (var i = 0; i <15; i++) {
      this.years[i] = anio+i;
    }
    this.fechaExp2=anio;
    var estados = '[{"value":"PR","label":"Puerto Rico"},{"value":"AL","label":"Alabama"},{"value":"AK","label":"Alaska"},{"value":"AZ","label":"Arizona"},{"value":"AR","label":"Arkansas"},{"value":"CA","label":"California"},{"value":"CO","label":"Colorado"},{"value":"CT","label":"Connecticut"},{"value":"DE","label":"Delaware"},{"value":"DC","label":"District Of Columbia"},{"value":"FL","label":"Florida"},{"value":"GA","label":"Georgia"},{"value":"HI","label":"Hawaii"},{"value":"ID","label":"Idaho"},{"value":"IL","label":"Illinois"},{"value":"IN","label":"Indiana"},{"value":"IA","label":"Iowa"},{"value":"KS","label":"Kansas"},{"value":"KY","label":"Kentucky"},{"value":"LA","label":"Louisiana"},{"value":"ME","label":"Maine"},{"value":"MD","label":"Maryland"},{"value":"MA","label":"Massachusetts"},{"value":"MI","label":"Michigan"},{"value":"MN","label":"Minnesota"},{"value":"MS","label":"Mississippi"},{"value":"MO","label":"Missouri"},{"value":"MT","label":"Montana"},{"value":"NE","label":"Nebraska"},{"value":"NV","label":"Nevada"},{"value":"NH","label":"New Hampshire"},{"value":"NJ","label":"New Jersey"},{"value":"NM","label":"New Mexico"},{"value":"NY","label":"New York"},{"value":"NC","label":"North Carolina"},{"value":"ND","label":"North Dakota"},{"value":"OH","label":"Ohio"},{"value":"OK","label":"Oklahoma"},{"value":"OR","label":"Oregon"},{"value":"PA","label":"Pennsylvania"},{"value":"RI","label":"Rhode Island"},{"value":"SC","label":"South Carolina"},{"value":"SD","label":"South Dakota"},{"value":"TN","label":"Tennessee"},{"value":"TX","label":"Texas"},{"value":"UT","label":"Utah"},{"value":"VT","label":"Vermont"},{"value":"VA","label":"Virginia"},{"value":"WA","label":"Washington"},{"value":"WV","label":"West Virginia"},{"value":"WI","label":"Wisconsin"},{"value":"WY","label":"Wyoming"}]';
    this.estados = JSON.parse(estados);
    this.estado = this.estados[0].value;
    this.returnPage=this.dataPay.data.module;
    this.amountPayable=this.dataPay.data.mount;
    this.equipmenttoPay=this.dataPay.data.product;
  }
  tipoTJ(tipo) {
    this.tipoTDC=tipo;
  }
  procesarPago() {
    if(this.global.validateSession()===true){
      this.loadingScreenService.startLoading();
      var sw=1;
      if(this.tipoTDC!=''){
        sw=0;
      }
      if(sw==1){
        this.global.notif("Debe seleccionar un tipo de tarjeta.");
      }
      else{
        if(this.NameOnCard==""){
          sw=1;
          this.global.notif("Debe colocar el nombre completo.");
        }
        else{
          if(this.idNroTejeta==""){
            sw=1;
            this.global.notif("Debe colocar el número de la tarjeta");
          }
          else{
            if(this.fechaExp1==""){
              sw=1;
              this.global.notif("Debe seleccionar la fecha de expiración");
            }
            else{
              if(this.fechaExp2==""){
                sw=1;
                this.global.notif("Debe seleccionar la fecha de expiración");
              }
              else{
                if(this.cvNum==""){
                  sw=1;
                  this.global.notif("Debe colocar el código de seguridad");
                }
                else{
                  if(this.direccion1==""){
                    sw=1;
                    this.global.notif("Debe colocar la dirección de facturación");
                  }
                  else{
                    if(this.ciudad==""){
                      sw=1;
                      this.global.notif("Debe colocar la ciudad");
                    }
                    else{
                      if(this.estado==""){
                        sw=1;
                          this.global.notif("Debe colocar el estado");
                      }
                      else{
                        if(this.zip==""){
                          sw=1;
                          this.global.notif("Debe colocar el código postal");
                        }
                        else{
                          sw=0;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      if(sw==0){
          this.services.getPersonalData(this.token,this.selectBan).subscribe(data =>{
            if(data.HasError ==false){//cable ==false
             sessionStorage.setItem("GetPersonalData",btoa(JSON.stringify(data)));
             this.emailGloba=data.Email;
             if(!this.emailGloba){
               this.emailGloba="email.coronado@gmail.com";
             }
             this.fechaExp=this.fechaExp1+""+this.fechaExp2;
             this.direccion=this.direccion1+this.direccion2;
             this.services.payment("Sale",this.idNroTejeta,this.fechaExp,"",this.NameOnCard,this.amountPayable,"","",this.zip,this.direccion,this.cvNum,"","MCWEB","jcoronado","V","7879100794","PR",this.ciudad,this.selectBan,this.equipmenttoPay,this.emailGloba,this.token).subscribe(data2 =>{
              if (data2.HasError == false) {
                // var numRef=data2.ETReference_Id;
                var paymentid=data2.paymentid;
                // var codReferencia="";
                // var codigoPostal=this.zip;
                // var resultado = '{"numRef":"' + numRef +'","codReferencia":"' + codReferencia +'","ciudad":"' + this.ciudad +'","estado":"' + this.estado +'","codigoPostal":"' + this.zip +'","tipoPag":"' + this.tipoTDC +'","dir1":"' + this.direccion +'"}';
                this.paymentID=data2.paymentid;
                this.confirmNum=data2.IVULottoHostAuthorizationCode;

                this.updateconfirmNum.emit(this.confirmNum);
                this.updatepaymentID.emit(this.paymentID);
                this.actualPrice=this.dataPay.data.mount;
                if(this.dataPay.data.module=='servicesandequipment'){
                  this.screen=2;
                  this.updatescreen.emit(this.screen);
                }
                else if(this.dataPay.data.module=='datapurchase'){
                  this.subscriberNumberPay=this.dataPay.data.params.subscriberNumberPay;
                    this.billCycleFieldPay=this.dataPay.data.params.billCycleFieldPay;
                    this.OfferIdPay=this.dataPay.data.params.OfferIdPay;
                    this.groupIDPay=this.dataPay.data.params.groupIDPay;
                    this.returnPage=this.dataPay.data.module;

                  if(this.groupIDPay=="" || this.groupIDPay==null||this.groupIDPay=='null'||this.groupIDPay=='undefined'){
                    this.AddOffersToSubscriber(this.subscriberNumberPay,this.billCycleFieldPay,this.OfferIdPay,"confirmacion",this.returnPage,paymentid,"0");
                  }
                  else{
                    this.AddOffersToGroup(this.subscriberNumberPay,this.billCycleFieldPay,this.OfferIdPay,"1234","confirmacion",this.returnPage,paymentid,"0");
                  }
                }
                else if(this.dataPay.data.module=='giveone'){
                  this.banSendPay=this.dataPay.data.params.banSendPay;
                  this.fullNamePay=this.dataPay.data.params.fullNamePay;
                  this.banRecievePay=this.dataPay.data.params.banRecievePay;
                  this.subsriberSendPay=this.dataPay.data.params.subsriberSendPay;
                  this.subsriberRecieverPay=this.dataPay.data.params.subsriberRecieverPay;
                  this.giftSendMessagePay=this.dataPay.data.params.giftSendMessagePay;
                  this.paymentID=this.dataPay.data.params.paymentID;

                  this.returnPage=this.dataPay.data.module;
                   this.addGift1GB();
                }
                else if(this.dataPay.data.module=='buysva'){
                  // this.buySVA(this.socSva, 'Y',this.amountPayable, this.equipmenttoPay);
                }
                else if(this.dataPay.data.module=='giverecharge'){
                  this.banSendPay=this.dataPay.data.params.banSendPay;
                  this.fullNamePay=this.dataPay.data.params.fullNamePay;
                  this.banRecievePay=this.dataPay.data.params.banRecievePay;
                  this.subsriberSendPay=this.dataPay.data.params.subsriberSendPay;
                  this.subsriberRecieverPay=this.dataPay.data.params.subsriberRecieverPay;
                  this.giftSendMessagePay=this.dataPay.data.params.giftSendMessagePay;
                  this.paymentID=this.dataPay.data.params.paymentID;

                  this.returnPage=this.dataPay.data.module;
                  this.giftRecharge();
                }
                else if(this.dataPay.data.params.service=="1"){
                  this.currentSoc=this.dataPay.data.params.currentSoc;
                  this.nextSoc=this.dataPay.data.params.nextSoc;
                  this.actualType=this.dataPay.data.params.actualType;
                  this.subscriberNumber=this.dataPay.data.params.subscriberNumber;
                  this.currentPlan=this.dataPay.data.params.currentPlan;
                  //this.activarPlanNow();
                    //cable
                    this.updateInitializeData.emit();
                    this.updatescreenview.emit(3);
                    this.updateNroOrder.emit(false);
                    this.screen=2;
                    this.updatescreen.emit(this.screen);
                    this.loadingScreenService.stopLoading();
                  //fin cable
                }
                else if(this.dataPay.data.params.service=="2"){
                  this.currentSoc=this.dataPay.data.params.currentSoc;
                  this.nextSoc=this.dataPay.data.params.nextSoc;
                  this.actualType=this.dataPay.data.params.actualType;
                  this.subscriberNumber=this.dataPay.data.params.subscriberNumber;
                  this.currentPlan=this.dataPay.data.params.currentPlan;
                  this.selectBan=this.dataPay.data.params.selectBan;
                  //this.activarPlanNext();
                  //cable
                    this.updateInitializeData.emit();
                    this.updatescreenview.emit(3);
                    this.updateNroOrder.emit(false);
                    this.screen=2;
                    this.updatescreen.emit(this.screen);
                    this.loadingScreenService.stopLoading();
                    //fin cable
                }
                else if(this.dataPay.data.params.service=="3"){
                  this.contractMonthsTxt=this.dataPay.data.params.contractMonthsTxt;
                  this.nextSoc=this.dataPay.data.params.nextSoc;
                  this.actualType=this.dataPay.data.params.actualType;
                  this.subscriberNumber=this.dataPay.data.params.subscriberNumber;
                  this.currentPlan=this.dataPay.data.params.currentPlan;
                  this.selectBan=this.dataPay.data.params.selectBan;
                  //this.adaDslPackageChange();
                    //cable
                    this.updateInitializeData.emit();
                    this.updatescreenview.emit(3);
                    this.updateNroOrder.emit(false);
                    this.screen=2;
                    this.updatescreen.emit(this.screen);
                    this.loadingScreenService.stopLoading();
                    //fin cable
                }
              }
              else {
                  this.global.notif(data2.ErrorDesc);
                  this.loadingScreenService.stopLoading();
              }
            });
            }
            else{
              this.global.notif(data.ErrorDesc);
              this.loadingScreenService.stopLoading();
            }
          });
      }
      else{
        this.loadingScreenService.stopLoading();
      }
    }
  }
  activarPlanNow() {
    this.loadingScreenService.startLoading();
    this.services.activarPlanNow(this.token, this.currentSoc,this.nextSoc, this.actualType, this.subscriberNumber).subscribe(data=> {
        this.updatescreenview.emit(3);
        if (data.HasError === false) {
            this.updateInitializeData.emit();
            this.updatescreenview.emit(3);
            this.updateNroOrder.emit(false);
            this.screen=2;
            this.updatescreen.emit(this.screen);
            this.loadingScreenService.stopLoading();
        }
        else {
        this.loadingScreenService.stopLoading();
            this.global.notif(data.ErrorDesc);
        }
    });
}
activarPlanNext() {
    this.loadingScreenService.startLoading();
    this.services.activarPlanNext(this.token,this.currentSoc,this.nextSoc,this.actualType, this.subscriberNumber,this.selectBan).subscribe(data=> {
        if (data.HasError === false) {
            this.updateInitializeData.emit();
            this.updatescreenview.emit(3);
            this.updateNroOrder.emit(false);
            this.screen=2;
            this.updatescreen.emit(this.screen);
            this.loadingScreenService.stopLoading();
        }
        else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.ErrorDesc);
        }
    });
}
adaDslPackageChange() {
    this.loadingScreenService.startLoading();
    this.services.adaDslPackageChange(this.token, this.contractMonthsTxt, 'Y',this.subscriberNumber, this.nextSoc,this.selectBan, this.actualPrice, this.actualType).subscribe(data=> {
        if (data.HasError === false) {
            //this.numberOrder = data.orderNumber;
            //this.message = data.ErrorDesc;
            this.updatescreenview.emit(3);
            if (data.orderNumber === '000000') {
                this.updateNroOrder.emit(false);
            }
            if (data.responseCode === '003') {
                this.updateNroOrder.emit(true);
            }
            if (data.responseCode === '004') {
                this.updateNroOrder.emit(true);
            }
            this.screen=2;
            this.updatescreen.emit(this.screen);
            this.loadingScreenService.stopLoading();
        }
        else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.ErrorDesc);
        }
    });
}
  AddOffersToGroup(SubscriberId, Cicle, OfferId,GroupId,tipo,returnPage,paymentID, Charge) {
    this.services.addOffersToGroup(SubscriberId,Cicle,OfferId,GroupId,paymentID,Charge,this.token,this.userName).subscribe(data =>{
      if (data.HasError === false) {
          if(data.ResultCode==0||data.ResultCode=="0"){
              this.global.notif('Se ha agregado el Plan Adicional de Data.');
              //ACTUALIZAR EL GETACOOUNT DETAIL y luego ir al home . averigurar que es la confirmacion?
              this.updateInitializeData.emit();
              this.loadingScreenService.stopLoading();
              this.screen=2;
              this.updatescreen.emit(this.screen);
            }
            else{
              this.loadingScreenService.stopLoading();
              this.global.notif('Estimado Cliente, ha ocurrido un error en el aprovisionamiento del paquete de datos. '+data.Description);
              this.router.navigate([this.returnPage]);
              //window.location.reload();
              this.updatescreenview.emit(3);
            }
        }
        else {
          this.loadingScreenService.stopLoading();
          this.global.notif(data.Description);
          this.router.navigate([this.returnPage]);
          //window.location.reload();
          this.updatescreenview.emit(3);
        }
    });
  }
  //this.AddOffersToSubscriber(this.subscriberNumberPay,this.billCycleFieldPay,this.OfferIdPay,"confirmacion",this.returnPage,paymentid,"0");
  AddOffersToSubscriber(SubscriberId, Cicle, OfferId,tipo,returnPage,paymentID, Charge) {
    //tefl,CY,IO,tipo,returnpage,idPay,Charge
    this.services.addOffersToSubscriber(SubscriberId,Cicle,OfferId,paymentID,Charge,this.token,this.userName).subscribe(data =>{
      if (data.HasError == false) {
        if(data.ResultCode==0||data.ResultCode=="0"){
          //ACTUALIZAR EL GETACOOUNT DETAIL y luego ir al home . averigurar que es la confirmacion?
          this.updateInitializeData.emit();
          this.loadingScreenService.stopLoading();
          this.screen=2;
          this.updatescreen.emit(this.screen);
        }
        else{
          this.loadingScreenService.stopLoading();
          this.global.notif('Estimado Cliente, ha ocurrido un error en el aprovisionamiento del paquete de datos. '+data.Description);
          this.router.navigate([this.returnPage]);
          this.updatescreenview.emit(3);
          //window.location.reload();
        }
    }
    else {
      this.loadingScreenService.stopLoading();
      this.global.notif(data.Description);
      this.router.navigate([this.returnPage]);
      this.updatescreenview.emit(3);
    }
  });
  }
  addGift1GB(){
    var paymentType=0; // 0 credito - 1 pago factura contra factura  7873822234
    this.services.AddGift1GB(this.token,this.banSendPay,this.fullNamePay,this.banRecievePay,this.subsriberSendPay,this.subsriberRecieverPay,this.giftSendMessagePay,this.paymentID,paymentType).subscribe(data => {
      if (data.HasError == false) {
        this.loadingScreenService.stopLoading();
        //this.global.notif(data.ErrorDesc);
        this.transactionId = data.Gift1GBIDTransact;
        this.updateInitializeData.emit();
        this.screen=2;
        this.updatescreen.emit(this.screen);
      }
      else {
        this.loadingScreenService.stopLoading();
        this.global.notif(data.ErrorDesc);
        this.router.navigate([this.returnPage]);
        this.updatescreenview.emit(3);
        //window.location.reload();
      }
    });
  }
  buySVA(soc, invoiceCharge, rent, description) {
    this.loadingScreenService.startLoading();
    this.services.buySVA(this.token,soc,this.selectBan,this.subscriberNumberSva,'WEB','N',rent).subscribe(data => {
    if(data.HasError==false){
      this.transactionId = data.object.transactionId;
      this.screen=2;
      this.updatescreen.emit(this.screen);
      this.updateInitializeData.emit();
      this.loadingScreenService.stopLoading();
      this.screen=2;
      this.updatescreen.emit(this.screen);
    }
    else{
      this.global.notif(data.ErrorDesc);
      this.loadingScreenService.stopLoading();
      this.router.navigate([this.returnPage]);
      this.updatescreenview.emit(3);
    }
  });
  }
  giftRecharge(){
      this.loadingScreenService.startLoading();
      this.services.giftRecharge(this.token,this.banSendPay,this.fullNamePay,this.banRecievePay,this.subsriberSendPay,this.subsriberRecieverPay,this.giftSendMessagePay,"",this.paymentTypePay,this.amountPayable,this.userName).subscribe(data => {
      if(data.HasError==false){
        this.transactionId=data.Gift1GBIDTransact;
        this.updateInitializeData.emit();
        this.screen=2;
        this.updatescreen.emit(this.screen);
        this.loadingScreenService.stopLoading();
      }
      else{
        this.global.notif(data.ErrorDesc);
        this.loadingScreenService.stopLoading();
        this.router.navigate([this.returnPage]);
        this.updatescreenview.emit(3);
      }
    });
  }
}
